module.exports = __webpack_public_path__ + "img/appltCourse-img3.a8d5ccbc.png";